const urlConstants = {
  users: {
    getUsers: '/api/users',
    deleteUser: '/api/users',
    grantProgram: (userId: string) => `/api/users/${userId}/grant-program`,
    removeProgram: (userId: string, purchaseId: string) => `/api/users/${userId}/programs/${purchaseId}`,
    updatePreferences: (userId: string) => `/api/users/${userId}/preferences`,
    bulkMigration: '/api/users/bulk-migration',
    programAccessReport: '/api/users/program-access-report',
    tempPassword: (userId: string) => `/api/users/admin/${userId}/temp-password`,
    setGender: (userId: string) => `/api/users/${userId}/gender`,
    setWorkoutsCompleted: (userId: string) => `/api/users/${userId}/workouts-completed`,
  },
  programInfo: {
    getSections: '/api/program-info',
    getAllSections: '/api/program-info/all',
    getTitles: '/api/program-info/getTitle',
    getProgram: '/api/program-info/:id',
    createSection: '/api/program-info',
    editSection: '/api/program-info',
    deleteSection: '/api/program-info',
    duplicateSection: '/api/program-info/duplicate',
  },
  categories: {
    getCategories: '/api/categories',
    createCategory: '/api/categories',
    editCategory: '/api/categories',
    deleteCategory: '/api/categories',
  },
  equipments: {
    getSectionstitle: '/api/program-info/getTitle',
    getEquipments: '/api/equipments',
    createEquipment: '/api/equipments',
    editEquipment: '/api/equipments',
    deleteEquipment: '/api/equipments',
  },
  videos: {
    getVideos: '/api/videos',
    createVideo: '/api/videos',
    deleteVideo: '/api/videos/deleteVideo',
  },
  exercises: {
    getExercises: '/api/exercises',
    getExercisestitle: '/api/exercises/getTitle',
    getCategoriestitle: '/api/categories/getTitle',
    getVideostitle: '/api/videos/getTitle',
    getEquipmentstitle: '/api/equipments/getTitle',
    createExercise: '/api/exercises',
    editExercise: '/api/exercises',
    deleteExercise: '/api/exercises',
    flushExerciseHistory: '/api/exercises/flush-history',
    flushAllReferences: '/api/exercises/flush-all-references',
  },
  resources: {
    getResources: '/api/resources',
    getResourcesTitle: '/api/resources/getTitle',
    getVideosTitle: '/api/videos/getTitle',
    createResource: '/api/resources',
    editResource: '/api/resources',
    deleteResource: '/api/resources',
  },
  restDays: {
    getRestDays: '/api/rest-days',
    getRestDaysTitle: '/api/rest-days/getTitle',
    getVideosTitle: '/api/videos/getTitle',
    createRestDay: '/api/rest-days',
    editRestDay: '/api/rest-days',
    deleteRestDay: '/api/rest-days',
  },
   homes: {
    getHomes: '/api/homes',
    createHome: '/api/homes',
    editHome: '/api/homes',
    deleteHome: '/api/homes',
  },
  warmups: {
    getWarmups: '/api/warmups',
    getWarmupsTitle: '/api/warmups/getTitle',
    createWarmup: '/api/warmups',
    editWarmup: '/api/warmups',
    deleteWarmup: '/api/warmups',
  },
  programIntros: {
    getProgramIntros: '/api/program-intros',
    createProgramIntro: '/api/program-intros',
    editProgramIntro: '/api/program-intros',
    deleteProgramIntro: '/api/program-intros',
    resetSeenProgramIntro: '/api/program-intros',
    getProgramTitles: '/api/program-info/getTitle',
  },
  homeIntros: {
    getHomeIntros: '/api/home-intros',
    createHomeIntro: '/api/home-intros',
    editHomeIntro: '/api/home-intros',
    deleteHomeIntro: '/api/home-intros',
    resetSeenHomeIntro: '/api/home-intros',
  },
  endPages: {
    getEndPages: '/api/end-pages',
    createEndPage: '/api/end-pages',
    editEndPage: '/api/end-pages',
    deleteEndPage: '/api/end-pages',
    getProgramTitles: '/api/program-info/getTitle',
  },
  appVersion: {
    get: '/api/app-version',
    update: '/api/app-version',
    userVersions: '/api/app-version/user-versions',
  },
};

export default urlConstants;
